import { basename as c } from "path";
import u, { toRaw as m } from "vue";
import { t as a, n as d } from "./chunks/toast-7xJhDYMn.mjs";
import { g as E, e as _, f as F, c as I, d as H, b as O, T as L, a as x, k as B, j as D, s as R, h as U, l as N, i as k } from "./chunks/toast-7xJhDYMn.mjs";
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const p = (e, t, i = () => {
}) => {
  const n = document.createElement("div");
  (document.querySelector(t?.container) || document.body).appendChild(n);
  const s = new u({
    el: n,
    name: "VueDialogHelper",
    render: (o) => o(e, {
      props: t,
      on: {
        close: (...l) => {
          i(...l.map((h) => m(h))), s.$destroy();
        }
      }
    })
  });
}, w = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-move" viewBox="0 0 24 24"><path d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" /></svg>', f = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-multiple" viewBox="0 0 24 24"><path d="M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z" /></svg>';
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var A = /* @__PURE__ */ ((e) => (e[e.Choose = 1] = "Choose", e[e.Move = 2] = "Move", e[e.Copy = 3] = "Copy", e[e.CopyMove = 4] = "CopyMove", e[e.Custom = 5] = "Custom", e))(A || {});
class b extends Error {
}
class T {
  title;
  multiSelect;
  mimeTypeFilter;
  directoriesAllowed;
  buttons;
  path;
  filter;
  container;
  constructor(t, i, n, r, s, o, l, h) {
    this.title = t, this.multiSelect = i, this.mimeTypeFilter = n, this.directoriesAllowed = r, this.path = o, this.filter = l, this.buttons = s, this.container = h;
  }
  /**
   * Pick files using the FilePicker
   *
   * @return Promise with array of picked files or rejected promise on close without picking
   */
  async pick() {
    const { FilePickerVue: t } = await import("./chunks/index-1zThpkd0.mjs");
    return new Promise((i, n) => {
      p(t, {
        allowPickDirectory: this.directoriesAllowed,
        buttons: this.buttons,
        container: this.container,
        name: this.title,
        path: this.path,
        mimetypeFilter: this.mimeTypeFilter,
        multiselect: this.multiSelect,
        filterFn: this.filter
      }, (...r) => {
        const [s] = r;
        !Array.isArray(s) || s.length === 0 ? n(new b("FilePicker: No nodes selected")) : this.multiSelect ? i(s.map((o) => o.path)) : i(s[0]?.path || "/");
      });
    });
  }
}
class y {
  title;
  multiSelect = !1;
  mimeTypeFilter = [];
  directoriesAllowed = !1;
  path;
  filter;
  buttons = [];
  container;
  /**
   * Construct a new FilePicker
   *
   * @param title Title of the FilePicker
   */
  constructor(t) {
    this.title = t;
  }
  /**
   * Set the container where the FilePicker will be mounted
   * By default 'body' is used
   *
   * @param container The dialog container
   */
  setContainer(t) {
    return this.container = t, this;
  }
  /**
   * Enable or disable picking multiple files
   *
   * @param ms True to enable picking multiple files, false otherwise
   */
  setMultiSelect(t) {
    return this.multiSelect = t, this;
  }
  /**
   * Add allowed MIME type
   *
   * @param filter MIME type to allow
   */
  addMimeTypeFilter(t) {
    return this.mimeTypeFilter.push(t), this;
  }
  /**
   * Set allowed MIME types
   *
   * @param filter Array of allowed MIME types
   */
  setMimeTypeFilter(t) {
    return this.mimeTypeFilter = t, this;
  }
  /**
   * Add a button to the FilePicker
   * Note: This overrides any previous `setButtonFactory` call
   *
   * @param button The button
   */
  addButton(t) {
    return typeof this.buttons == "function" && (console.warn("FilePicker buttons were set to factory, now overwritten with button object."), this.buttons = []), this.buttons.push(t), this;
  }
  /**
   * Set the button factory which is used to generate buttons from current view, path and selected nodes
   * Note: This overrides any previous `addButton` call
   *
   * @param factory The button factory
   */
  setButtonFactory(t) {
    return this.buttons = t, this;
  }
  /**
   * Set FilePicker type based on legacy file picker types
   * @param type The legacy filepicker type to emulate
   * @deprecated Use `addButton` or `setButtonFactory` instead as with setType you do not know which button was pressed
   */
  setType(t) {
    return this.buttons = (i, n) => {
      const r = [], s = i?.[0]?.attributes?.displayName || i?.[0]?.basename, o = s || c(n);
      if (t === 1) {
        let l = a("Choose");
        i.length === 1 ? l = a("Choose {file}", { file: s }) : this.multiSelect && (l = d("Choose %n file", "Choose %n files", i.length)), r.push({
          callback: () => {
          },
          type: "primary",
          label: l
        });
      }
      return (t === 4 || t === 3) && r.push({
        callback: () => {
        },
        label: o ? a("Copy to {target}", { target: o }) : a("Copy"),
        type: "primary",
        icon: f
      }), (t === 2 || t === 4) && r.push({
        callback: () => {
        },
        label: o ? a("Move to {target}", { target: o }) : a("Move"),
        type: t === 2 ? "primary" : "secondary",
        icon: w
      }), r;
    }, this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  allowDirectories(t = !0) {
    return this.directoriesAllowed = t, this;
  }
  /**
   * Set starting path of the FilePicker
   *
   * @param path Path to start from picking
   */
  startAt(t) {
    return this.path = t, this;
  }
  /**
   * Add filter function to filter file list of FilePicker
   *
   * @param filter Filter function to apply
   */
  setFilter(t) {
    return this.filter = t, this;
  }
  /**
   * Construct the configured FilePicker
   */
  build() {
    return new T(
      this.title,
      this.multiSelect,
      this.mimeTypeFilter,
      this.directoriesAllowed,
      this.buttons,
      this.path,
      this.filter
    );
  }
}
function M(e) {
  return new y(e);
}
export {
  T as FilePicker,
  y as FilePickerBuilder,
  b as FilePickerClosed,
  A as FilePickerType,
  E as TOAST_ARIA_LIVE_ASSERTIVE,
  _ as TOAST_ARIA_LIVE_OFF,
  F as TOAST_ARIA_LIVE_POLITE,
  I as TOAST_DEFAULT_TIMEOUT,
  H as TOAST_PERMANENT_TIMEOUT,
  O as TOAST_UNDO_TIMEOUT,
  L as ToastAriaLive,
  x as ToastType,
  M as getFilePickerBuilder,
  B as showError,
  D as showInfo,
  R as showMessage,
  U as showSuccess,
  N as showUndo,
  k as showWarning,
  p as spawnDialog
};
